import ActionType from "../ActionType";

export const setTransportRoundTrip = (data: boolean) => ({
  type: ActionType.TRANSPORT_ROUND_TRIP,
  data: data,
});
